import React, { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { format } from "date-fns"
import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { calculateTotal } from "../../Utility/utility.js"
import {
  MainContainer,
  NextUITable,
  ErrorCard,
  LoadingCard,
} from "../../components/index.js"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
} from "../../components/NextUITable.jsx"

const MultiAccountLedger = () => {
  const navigate = useNavigate()

  const { filter, account } = useSelector((state) => state.ledger)
  const { user } = useSelector((state) => state.auth)
  const { compCode, isMultipleCompany,  objCompanies } = useSelector((state) => state.company)
  // const [data, setData] = useState([])

  const {
    isPending,
    isError,
    data = [],// AccountData = [],
    mutate: getAccountLedger
  } = usePost({
    url: apiRoute.ledger.multiAccount.fetch,
    queryKey: "LedgerMultiAccount",
  })
  
  const {
    isPending: isAddressPending,
    data: addressData = [],
    mutate: fetchAddress,
  } = useFetchWithBody({
    url: apiRoute.outstanding.partyInfo,
    queryKey: "OutstandingPayablePartySummary-Address",
    inputData: {
      compcode: compCode.join(","),
      party_id: account.acId,
    }
  })
  const funLoadData = () => {

    getAccountLedger({
      data: {
        compcode: account.compCode,
        dy: 1,
        ac_id: account.acId,
        fromdate: new Date(filter.fromdate).toISOString().split("T")[0],
        todate: new Date(filter.todate).toISOString().split("T")[0],
        compcode_list: compCode.join(",")
      }
    })
  }
  useEffect(() => {
    if (!isMultipleCompany)
      navigate(linksUrl.ledger.getAccount)
    else
      funLoadData()
  }, [])

  const accCompData = useMemo(() => {
    if (objCompanies && objCompanies.length > 0 && account)
      return objCompanies.filter(ele => ele.COMPCODE == account.compCode)
    else
      return []
  })

  const totalDebit = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Debit",
      }),
    [data]
  )
  const totalCredit = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Credit",
      }),
    [data]
  )


  let downloadDataFooter = {
    Trn_Date: "",
    Particular: "",
    Doc_No: "",
    Debit: "Total: " + totalDebit,
    Credit: "Total: " + totalCredit,
    Balance: "Total: " + Number(totalDebit - totalCredit).toFixed(2),
    Bal_Type: "",
    Remark: "",
  }
  let downloadFileHeader = [
    {
      key: "Head",
      val1: accCompData && accCompData?.length > 0 ? accCompData[0]?.COMPNAME : "",
      val2: account.acDesc && account.acDesc != "" ? account.acDesc : "",
      val3: accCompData && accCompData?.length>0 ? accCompData[0]?.COMP_ADDRESS:"",
      val4: addressData && addressData.length > 0 ? addressData[0]?.Party_Address : "",
      val5: accCompData && accCompData?.length > 0 ? accCompData[0]?.IT_NO : "",
      val6: addressData && addressData.length > 0 ? addressData[0]?.IT_NO : ""
    },
    {
      key: "Date",
      value:
        format(new Date(filter.fromdate), "dd/MM/yyyy") +
        " To " +
        format(new Date(filter.todate), "dd/MM/yyyy"),
    },
  ]
  const exportColumns = [
    {
      uid: "Trn_Date",
      name: "Date",
      type: COLUMN_TYPE.date,
    },
    {
      uid: "Particular",
      name: "Particular",
    },

    {
      uid: "Doc_No",
      name: "Doc. No.",
    },
    {
      uid: "Debit",
      name: "Debit",
    },
    {
      uid: "Credit",
      name: "Credit",
    },
    {
      uid: "Balance",
      name: "Balance",
    },
    {
      uid: "Bal_Type",
      name: "",
    },
    {
      uid: "Remark",
      name: "Narration",
    },
  ]

  const handleClickPrev = () => {
    navigate(linksUrl.ledger.get)
  }

  const INITIAL_VISIBLE_COLUMNS = [
    "Trn_Date",
    "Particular",
    "Doc_No",
    "Debit",
    "Credit",
    "Balance",
    "Bal_Type",
    "Remark",
  ]

  const columns = [
    {
      uid: "Trn_Date",
      name: "Transaction Date",
      type: COLUMN_TYPE.date,
      sortable: true,
    },
    {
      uid: "Particular",
      name: "Particular",
      sortable: true,
    },

    {
      uid: "Doc_No",
      name: "Doc. No.",
      sortable: true,
    },
    {
      uid: "Debit",
      name: "Debit",
      align: COLUMN_ALIGN_TYPE.right,
      sortable: true,

      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalDebit,
      },
    },
    {
      uid: "Credit",
      name: "Credit",
      align: COLUMN_ALIGN_TYPE.right,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalCredit,
      },
    },
    {
      uid: "Balance",
      name: "Balance",
      align: COLUMN_ALIGN_TYPE.right,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: Number(totalDebit - totalCredit).toFixed(2),
      },
    },
    {
      uid: "Bal_Type",
      name: "",
      sortable: true,
    },
    {
      uid: "Remark",
      name: "Narration",
      sortable: true,
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }
  return (
    <div>
      <MainContainer
        pageName="Account Ledger"
        info={[
          ["Account :", account.acDesc],
          ["Account Type :", filter.actypename],
          [
            "Date",
            format(new Date(filter.fromdate), "dd/MM/yyyy"),
            "to",
            format(new Date(filter.todate), "dd/MM/yyyy"),
          ],
        ]}
        breadcrumbs={["Ledger", "Account Ledger"]}
        prevPage={{
          show: true,
          onClick: handleClickPrev,
        }}
      >
        {/* end of filter */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          exportReportType="Ledger"
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Account_Ledger"
          downloadFileHeader={downloadFileHeader}
          showAdvanceFilter={false}
          id="ac_id"
        />
      </MainContainer>
    </div>
  )
}

export default MultiAccountLedger
